"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagFM = function FlagFM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.87-83.36,5.43-67l-17.2.13a1,1,0,0,0-.57,1.77L1.49-54.93-3.7-38.54a1,1,0,0,0,1.51,1.1l14-10,14,10a1,1,0,0,0,1.51-1.1L22.11-54.93,35.94-65.15a1,1,0,0,0-.57-1.77L18.17-67,12.73-83.36a1,1,0,0,0-1.86,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.87,62.28,5.43,78.6l-17.2.13a1,1,0,0,0-.57,1.77L1.49,90.72-3.7,107.11a1,1,0,0,0,1.51,1.1l14-10,14,10a1,1,0,0,0,1.51-1.1L22.11,90.72,35.94,80.5a1,1,0,0,0-.57-1.77l-17.2-.13L12.73,62.28a1,1,0,0,0-1.86,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M107.34,11.25,91,5.81l-.13-17.2A1,1,0,0,0,89.12-12L78.91,1.87,62.52-3.32a1,1,0,0,0-1.1,1.51l10,14-10,14a1,1,0,0,0,1.1,1.51l16.39-5.19L89.12,36.32a1,1,0,0,0,1.78-.57L91,18.55l16.31-5.44a1,1,0,0,0,0-1.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.75,11.25l16.32-5.44.13-17.2A1,1,0,0,1-65.53-12L-55.31,1.87l16.4-5.19a1,1,0,0,1,1.09,1.51l-10,14,10,14a1,1,0,0,1-1.09,1.51l-16.4-5.19L-65.53,36.32a1,1,0,0,1-1.77-.57l-.13-17.2-16.32-5.44a1,1,0,0,1,0-1.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagFM;
exports["default"] = _default;